const PILLARS = [
  {
    n: "01",
    title: "Clasificación estricta",
    body: "Separamos y evaluamos cada unidad según su nivel de uso, geometría y resistencia. Lo que sale del patio cumple norma de carga industrial.",
  },
  {
    n: "02",
    title: "Sustentabilidad real",
    body: "Reparamos y extendemos la vida útil de la madera. Tu empresa avanza en sus metas ambientales mientras optimiza costos.",
  },
  {
    n: "03",
    title: "Puntualidad de despacho",
    body: "Coordinación logística impecable. Tus camiones no esperan y tu operación no se detiene por falta de pallets.",
  },
];

const QUALITY_IMG =
  "https://images.unsplash.com/photo-1573209680076-bd7ec7007616?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwd29vZGVuJTIwcGFsbGV0cyUyMHdhcmVob3VzZXxlbnwwfHx8fDE3Nzg4NDc2MzR8MA&ixlib=rb-4.1.0&q=85";

export default function Quality() {
  return (
    <section
      id="calidad"
      data-testid="quality-section"
      className="bg-vp-navy border-b-2 border-vp-yellow"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12">
        <div className="lg:col-span-5 relative min-h-[320px] lg:min-h-[700px] border-b-2 lg:border-b-0 lg:border-r-2 border-white/15">
          <img
            src={QUALITY_IMG}
            alt="Pallets de madera de alta calidad listos para despacho"
            className="absolute inset-0 w-full h-full object-cover opacity-90"
          />
          <div className="absolute inset-0 bg-gradient-to-tr from-[#001E62]/60 to-transparent" />
          <div className="absolute top-0 left-0 bg-vp-yellow text-[#001E62] px-6 py-3">
            <div className="text-[10px] font-bold tracking-[0.18em] uppercase opacity-70">Vigopal</div>
            <div className="font-bold uppercase">Estándares de calidad</div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="px-6 lg:px-12 py-12 lg:py-14 border-b-2 border-white/15">
            <div className="flex items-center gap-3 mb-4">
              <span className="w-10 h-[2px] bg-vp-red" />
              <span className="label-industrial">04 · Certeza operacional</span>
            </div>
            <h2 className="heading-industrial text-4xl sm:text-5xl text-white">
              Un pallet roto
              <br />
              <span className="text-vp-yellow">cuesta caro.</span>
            </h2>
            <p className="mt-4 text-white/75 max-w-xl">
              En este rubro un error logístico se traduce en pérdida directa.
              Por eso operamos con tres pilares no negociables.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3">
            {PILLARS.map((p, i) => (
              <div
                key={p.n}
                className={`px-6 lg:px-8 py-10 relative overflow-hidden bg-vp-navy hover:bg-vp-red transition-colors group ${
                  i < PILLARS.length - 1
                    ? "sm:border-r-2 border-white/15"
                    : ""
                } border-b-2 sm:border-b-0 border-white/15 last:border-b-0`}
              >
                <span
                  className="absolute -bottom-4 -right-2 heading-industrial text-[7rem] leading-none text-white/5 group-hover:text-white/20 transition-colors pointer-events-none select-none"
                  aria-hidden="true"
                >
                  {p.n}
                </span>
                <div className="relative">
                  <div className="text-[10px] font-bold tracking-[0.18em] uppercase text-vp-yellow group-hover:text-white mb-3">
                    Pilar {p.n}
                  </div>
                  <h3 className="font-black uppercase tracking-tight text-xl mb-3 text-white">
                    {p.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-white/75 group-hover:text-white/90">
                    {p.body}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
